import { useState } from 'react';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../../config/config';
import { revenueStatusCell } from '../../../helpers/revenueStatusCell';
import { createRevenueActionsCell } from '../../../helpers/revenueActionsCell';
import { useDispatch } from 'react-redux';
import ApproveRevenue from '../../Revenues/Modals/ApproveRevenue';
import ReproveRevenue from '../../Revenues/Modals/ReproveRevenue';
import { VerifyAction } from '../../../../core/util/core/VerifyPermission';
import Fetch from '../../../../core/util/core/Fetch';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import CancelServiceContractRevenues from '../Modals/CancelServiceContractRevenues';
import ResyncServiceContractRevenues from '../Modals/ResyncServiceContractRevenues';

function List({ formValues }) {

    const dispatch = useDispatch();

    const canCancelRevenues = VerifyAction('cancel_sale_revenues');

    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showReproveModal, setShowReproveModal] = useState(false);
    const [selectedRevenue, setSelectedRevenue] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showResyncModal, setShowResyncModal] = useState(false);

    const openApproveModal = (revenue) => {
        setSelectedRevenue(revenue);
        setShowApproveModal(true);
    };

    const openReproveModal = (revenue) => {
        setSelectedRevenue(revenue);
        setShowReproveModal(true);
    };

    const handleCloseModal = () => {
        setSelectedRevenue(null);
        setShowApproveModal(false);
        setShowReproveModal(false);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    const pathFrontEnd = '/gci/revenues/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/revenues/delete`,
        endpoint: `${endpointBackend}gci/revenues/getall`,
        endpointCancelRevenuesByServiceContract: `${endpointBackend}gci/revenues/cancelByServiceContract`,
        endpointResyncRevenuesByServiceContract: `${endpointBackend}gci/revenues/resyncByServiceContract`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'due_date',
                name_start: 'due_date_start',
                name_end: 'due_date_end',
                type: 'date_period',
                label: 'Data de Vencimento',
                validations: {
                    required: false,
                },
                columnSize: 4,
            },
            {
                name: 'status',
                type: 'select',
                label: 'Status da Receita',
                options: [
                    { label: 'Pendente', value: 'pending' },
                    { label: 'Recebido', value: 'received' },
                    { label: 'Parcial', value: 'partially_received' },
                    { label: 'Em Atraso', value: 'overdue' },
                    { label: 'Cancelada', value: 'cancelled' }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Receitas do Contrato',
        canDelete: false,
        formFilters: filters,
        filter: {
            gci_service_contract_id: formValues?.id
        },
        columns: [
            {
                name: 'accounting_plan',
                label: 'Plano de Contas',
            },
            {
                name: 'installment_number',
                label: 'Parcela',
                width: '8%'
            },
            {
                name: 'value',
                label: 'Valor',
            },
            {
                name: 'total_received',
                label: 'Valor Recebido',
            },
            {
                name: 'payment_method',
                label: 'Forma de Pagamento',
            },
            {
                name: 'due_date',
                label: 'Data de Vencimento',
            },
            {
                name: 'formattedStatus',
                label: 'Status',
                width: '14%',
                cell: revenueStatusCell
            },
            {
                name: 'approval',
                label: 'Ações',
                width: '10%',
                cell: createRevenueActionsCell(openApproveModal, openReproveModal)
            }
        ],
        buttonsListContainer: [
            canCancelRevenues ? {
                name: 'cancel_service_contract_revenues',
                class: 'btn btn-secondary',
                label: 'Cancelar Receitas',
                tooltipLabel: 'Cancelar Todas as Receitas',
                callback: () => {
                    setShowCancelModal(true);
                }
            } : {},
            {
                name: 'resync_service_contract_revenues',
                class: 'btn btn-primary',
                label: 'Sincronizar Receitas',
                tooltipLabel: 'Sincronizar Formas de Pagamento do Contrato',
                callback: () => {
                    setShowResyncModal(true);
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={false}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                buttons={list.buttonsListContainer}
                content={<CustomList list={{ ...list, ...paths }} />}
            />

            {showApproveModal && (
                <ApproveRevenue
                    show={showApproveModal}
                    onClose={handleCloseModal}
                    revenueId={selectedRevenue?.id}
                />
            )}

            {showReproveModal && (
                <ReproveRevenue
                    show={showReproveModal}
                    onClose={handleCloseModal}
                    revenueId={selectedRevenue?.id}
                />
            )}

            {/* --------------------------
                MODAL DE CONFIRMAÇÃO - CANCELAR TODAS AS RECEITAS
            --------------------------- */}
            {showCancelModal && (
                <CancelServiceContractRevenues
                    show={showCancelModal}
                    onClose={() => setShowCancelModal(false)}
                    onConfirm={async () => {
                        setShowCancelModal(false);
                        try {
                            const response = await Fetch.post(paths.endpointCancelRevenuesByServiceContract, {
                                gci_service_contract_id: formValues?.id
                            });
                            if (response?.status == "0") {
                                Toast.error(response.message || 'Erro ao cancelar receitas.');
                            } else {
                                Toast.success(response?.message || 'Receitas canceladas com sucesso.');
                                dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
                            }
                        } catch (err) {
                            Toast.error(err?.message || 'Erro inesperado ao cancelar receitas.');
                        }
                    }}
                />
            )}

            {/* --------------------------
                MODAL DE CONFIRMAÇÃO - SINCRONIZAR RECEITAS
            --------------------------- */}
            {showResyncModal && (
                <ResyncServiceContractRevenues
                    show={showResyncModal}
                    onClose={() => setShowResyncModal(false)}
                    onConfirm={async () => {
                        setShowResyncModal(false);
                        try {
                            const response = await Fetch.post(paths.endpointResyncRevenuesByServiceContract, {
                                gci_service_contract_id: formValues?.id
                            });
                            if (response?.status == "0") {
                                Toast.error(response.message || 'Erro ao sincronizar receitas.');
                            } else {
                                Toast.success(response?.message || 'Receitas sincronizadas com sucesso.');
                                dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
                            }
                        } catch (err) {
                            Toast.error(err?.message || 'Erro inesperado ao sincronizar receitas.');
                        }
                    }}
                />
            )}
        </div>
    );
}
export default List;
